import React from 'react';
import { FiTrendingUp, FiArrowRight } from 'react-icons/fi';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* Pre-Footer CTA */}
      <section className="bg-emerald-600 py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-emerald-400/40 via-transparent to-transparent"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Ready to learn land flipping?</h2>
          <p className="text-emerald-100 text-lg mb-10 max-w-2xl mx-auto">
            Join our growing community of successful students who are leveraging our education products and services to build wealth in real estate.
          </p>
          <a 
            href="#get-offer" 
            onClick={(e) => handleNavClick(e, 'get-offer')}
            className="inline-flex items-center gap-2 bg-white text-emerald-700 px-8 py-4 rounded-xl font-bold text-lg shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
          >
            Start Your Journey <SafeIcon icon={FiArrowRight} />
          </a>
        </div>
      </section>

      {/* Main Footer */}
      <footer className="bg-slate-950 text-slate-400 py-16 border-t border-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            
            <div className="col-span-1 md:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-6 group inline-flex">
                <div className="p-2 bg-emerald-600/20 rounded-lg group-hover:bg-emerald-600/30 transition-colors">
                  <SafeIcon icon={FiTrendingUp} className="text-2xl text-emerald-500" />
                </div>
                <span className="text-2xl font-extrabold tracking-tight text-white group-hover:text-emerald-50 transition-colors">
                  Toptier<span className="text-emerald-500">Ventures</span>
                </span>
              </Link>
              <p className="text-slate-400 max-w-md leading-relaxed font-light mb-4">
                Toptier Ventures LLC is a premier real estate education company helping homeowners and business owners learn how to make money flipping land.
              </p>
              <p className="text-slate-500 text-sm font-medium">
                Direct Contact: 251-235-2120
              </p>
            </div>

            <div>
              <h4 className="text-white font-bold mb-6 tracking-wide uppercase text-sm">Quick Links</h4>
              <ul className="space-y-4 text-sm font-light">
                <li><a href="#how-it-works" onClick={(e) => handleNavClick(e, 'how-it-works')} className="hover:text-emerald-400 transition-colors cursor-pointer">Curriculum</a></li>
                <li><a href="#benefits" onClick={(e) => handleNavClick(e, 'benefits')} className="hover:text-emerald-400 transition-colors cursor-pointer">Why Us</a></li>
                <li><a href="#founder" onClick={(e) => handleNavClick(e, 'founder')} className="hover:text-emerald-400 transition-colors cursor-pointer">Meet Andrew</a></li>
                <li><a href="#get-offer" onClick={(e) => handleNavClick(e, 'get-offer')} className="hover:text-emerald-400 transition-colors cursor-pointer">Start Learning</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-6 tracking-wide uppercase text-sm">Legal</h4>
              <ul className="space-y-4 text-sm font-light">
                <li><Link to="/privacy" className="hover:text-emerald-400 transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms" className="hover:text-emerald-400 transition-colors">Terms of Service</Link></li>
                <li><Link to="/sms-compliance" className="hover:text-emerald-400 transition-colors">SMS Compliance</Link></li>
              </ul>
            </div>

          </div>

          <div className="pt-8 border-t border-slate-800/50 text-sm flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="whitespace-nowrap">&copy; {new Date().getFullYear()} Toptier Ventures LLC. All rights reserved.</p>
            <p className="text-xs max-w-2xl text-center md:text-right text-slate-500 leading-relaxed">
              By submitting web forms on this site and opting into SMS, you agree to receive text messages from Toptier Ventures LLC regarding educational products. Message and data rates may apply. Message frequency varies. Reply HELP for help or STOP to opt-out at any time.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;